import React, { useState, useEffect } from 'react';
import { Container, Col, Row, Modal, Button } from 'react-bootstrap';
import apiRequests from './api-helpers/ApiRequests';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const EditDictionaryItemCars = ({
    show,
    onChangeEditItemFormVisibilityHandler,
    editEventNotificationCallback,
    userData,
    editedItem,
}) => {
    const [editedCar, setEditedCar] = useState({});
    const [errors, setErrors] = useState("");
    const [isValidForm, setIsValidForm] = useState(true);
    const [brandsList, setBrandsList] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        loadBrandsList();

        if (editedItem && editedItem.cells) {
            setEditedCar({
                CarId: editedItem.id,
                Mark: editedItem.cells[1].value || "",
                RegistationNumber: editedItem.cells[2].value || "",
                CompanyWorkflowId: userData.CompanyWorkflowId + "",
                AccountWorkflowId: userData.AccountWorkflowId + "",
            });
        }
    }, [editedItem]);

    const hideModal = () => {
        setEditedCar({});
        setErrors("");
        setIsValidForm(true);
        onChangeEditItemFormVisibilityHandler(false);
    };

    const loadBrandsList = () => {
        const params = {
            DataInHttpResponse: true,
            SearchParams: [],
            ReportID: "90",
        };

        apiRequests.getDataByUrlWithParam('webconapi/GetWebconReport', params, (data) => {
            if (data?.rows?.length > 0) {
                const brands = data.rows.map(row => ({
                    Name: row.cells[1].value,
                }));
                setBrandsList(brands);
            }
        });
    };

    const onInputChange = (event) => {
        const { name, value } = event.target;

        if (name === "Mark") {
            setEditedCar(prev => {
                const updated = { ...prev, [name]: value };

                if (!isValidForm) {
                    apiRequests.getDataByUrlWithParam('webconapi/AddNewCarValidate', updated, handleValidationResponse);
                }

                return updated;
            });
        }
    };

    const handleValidationResponse = (data) => {
        if (data.errors) {
            setErrors(data.errors);
            setIsValidForm(false);
        } else {
            setErrors("");
            setIsValidForm(true);
        }
    };

    const onFormSubmit = (event) => {
        event.preventDefault();

        const payload = {
            ...editedCar,
            CompanyWorkflowId: userData.CompanyWorkflowId + "",
            AccountWorkflowId: userData.AccountWorkflowId + "",
        };

        apiRequests.getDataByUrlWithParam('webconapi/EditCar', payload, (data, response) => {
            if (response.status === 400 && data.errors) {
                setErrors(data.errors);
                setIsValidForm(false);
            } else if (response.status === 200 && data.Message === "ok") {
                hideModal();
                editEventNotificationCallback();
            }
        });
    };

    return (
        <Modal show={show} onHide={hideModal}>
            <Modal.Header closeButton>
                <Modal.Title>{t('cars.modalEditTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id="edit-car-form" className="form-font" onSubmit={onFormSubmit}>
                    <div className="mb-3">
                        <label htmlFor="mark" className="form-label m-0 p-0">
                            <sup className="text-danger">*</sup>{t('cars.modal.brandLabel')}
                        </label>
                        <select
                            className="form-control"
                            id="mark"
                            name="Mark"
                            value={editedCar.Mark || ""}
                            onChange={onInputChange}
                            required
                        >
                            <option value="">{t('cars.modal.brandPlaceholder')}</option>
                            {brandsList.map((brand, index) => (
                                <option key={index} value={brand.Name}>{brand.Name}</option>
                            ))}
                        </select>
                        <span className="text-danger">
                            {errors.Mark ? errors.Mark[0] : ""}
                        </span>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="registationNumber" className="form-label m-0 p-0">
                            {t('cars.modal.registrationLabel')}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="registationNumber"
                            name="RegistationNumber"
                            value={editedCar.RegistationNumber || ""}
                            disabled
                        />
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button form="edit-car-form" type="submit" className="btn btn-primary">
                    {t('common.save')}
                </button>
                <Button variant="secondary" onClick={hideModal}>
                    {t('common.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditDictionaryItemCars;
